// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let EmailRegexJs = require("./emailRegex.js").default;

let emailRegex = EmailRegexJs;

function isEmail(email) {
  return emailRegex.test(email);
}

exports.emailRegex = emailRegex;
exports.isEmail = isEmail;
/* emailRegex Not a pure module */
